import { render, staticRenderFns } from "./ShareComponentArticle.vue?vue&type=template&id=68b43587&scoped=true&"
import script from "./ShareComponentArticle.vue?vue&type=script&lang=js&"
export * from "./ShareComponentArticle.vue?vue&type=script&lang=js&"
import style0 from "./ShareComponentArticle.vue?vue&type=style&index=0&id=68b43587&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../Users/katonobo/Documents/Web App/dream-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68b43587",
  null
  
)

export default component.exports